export const DEFAULT_SERVICE_ID = 'd64d5d0a-9fea-412f-a439-dfd800c92dc9'

export default function openKf5Concat(serviceId = DEFAULT_SERVICE_ID) {
  if (!serviceId) {
    serviceId = DEFAULT_SERVICE_ID
  }
  openClinkChat(serviceId)
}

// src/utils/clinkChat.js

/**
 * 初始化 Clink Webchat
 * @param {string} accessId - 接入的 Access ID
 * @param {string} language - (可选) 语言，默认为 zh_CN
 */
export function initClinkWebChat(accessId, language = 'zh_CN') {
  const optName = 'clinkWebchatOptions'

  // 1. 初始化全局配置函数 (对应原代码中的 win[opt] = ...)
  window[optName] = window[optName] || function () {
    window[optName].options = arguments[0]
  }

  // 2. 检查脚本是否已经注入，避免重复添加 script 标签
  const scriptId = 'clink-webchat-script'
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script')
    script.id = scriptId // 给标签加个ID方便后续查找
    script.async = 1
    // 保留原代码中的防缓存逻辑 (v=Date.now())
    script.src = `https://webchat-bj.clink.cn/webchat.js?v=${Date.now()}`
    document.body.appendChild(script)
  }

  // 3. 调用配置，传入动态的 accessId
  window[optName]({
    accessId,
    language,
    visitorExtraInfo: encodeURIComponent(JSON.stringify({
      链接: window.location.href,
    })),
  })
}

export function openClinkChat(accessId) {
  if (!openChat()) {
    initClinkWebChat(accessId)
  }
  openChat()
}

function openChat() {
  const targetBtn = document.getElementById('tinet-chat-visitor')
        || document.querySelector('.tinet-chat-visitor')
        || document.querySelector('[id^="tinet-chat"]') // 模糊匹配
  if (!targetBtn) {
    return false
  }
  targetBtn.click()
}

